export default __webpack_public_path__ + "static/media/eco_img_03.053fbb44.png";